import React from 'react';

import { Container, LeftColumn, RightColumn } from '@components/AuthLayout/styles';

type AcceptLayoutProps = {
  children: React.ReactNode;
};

function AcceptLayout({ children }: AcceptLayoutProps) {
  return (
    <Container>
      <LeftColumn />
      <RightColumn className="auth-layout">{children}</RightColumn>
    </Container>
  );
}

export default AcceptLayout;
